// Données de navigation pour la catégorie Astrologie (articles généraux)
export const astrologieNavItems = [
  {
    title: "Quel est le signe le plus difficile ?",
    image: "/images/blog/phases_de_la_lune.webp",
    url: "/blog/astrologie/signe-le-plus-difficile"
  },
  {
    title: "Quel est le signe le plus intelligent ?",
    image: "/images/blog/phases_de_la_lune.webp",
    url: "/blog/astrologie/signe-le-plus-intelligent"
  }
];


